import Hero from "./Hero/Hero";
import MobileHero from "./Hero/MobileHero";
import Services from "./Services/Services";
import MobileServices from "./Services/MobileServices";
import Projects from "./Projects/Projects";
import Partners from "./Partners/Partners";

// fetching
import { useEffect, useState } from "react";
import useFetch from "Hooks/useFetch";
import LoadingScreen from "Components/RequestHandler/LoadingScreen";
import IsError from "Components/RequestHandler/IsError";

const Home = () => {
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData("home");
      setData(data?.homeData);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(true);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setLoadingProgress((prev) => {
        const nextValue = prev + 10;
        if (nextValue >= 100) {
          clearInterval(interval);
          return 100;
        }
        return nextValue;
      });
    }, 300); // Simulating loading progress every 300ms

    return () => clearInterval(interval);
  }, []);

  if (isLoading && loadingProgress < 100) {
    return <LoadingScreen progress={loadingProgress} />;
  }
  if (error || isError) return <IsError />;
  else if (data) {
    return (
      <main className="bg-primary">
        <Hero data={data?.hero} />
        <MobileHero data={data?.hero} />
        <Services data={data?.services} />
        <MobileServices data={data?.services} />
        <Projects data={data?.projects} />
        <Partners data={data?.clients} />
      </main>
    );
  }
};

export default Home;
